import React from "react";
import { FormGroup, Label, Button } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FiltrosCompromisos = ({
  filtros,
  onChange,
  onFiltrar,
  onLimpiar
}) => {
  const handleFechaChange = (nombre, fecha) => {
    onChange(nombre, fecha);
  };

  // Estilo unificado para los Labels
  const labelStyle = {
    fontSize: "0.85rem",
    marginBottom: "4px",
    display: "block",
    color: "#333",
    fontWeight: "600",
    lineHeight: "1.2"
  };

  return (
    <div className="mb-3">
      <div className="d-flex flex-wrap align-items-start" style={{ gap: "10px" }}>
        
        {/* FECHA DESDE */}
        <FormGroup className="mb-0" style={{ width: "220px" }}>
          <Label htmlFor="fecha-desde" style={labelStyle}>
            Fecha desde
          </Label>
          <DatePicker
            selected={filtros.fechaDesde}
            onChange={(fecha) => handleFechaChange("fechaDesde", fecha)}
            dateFormat="dd/MM/yyyy"
            className="form-control"
            placeholderText="dd-mm-aaaa"
            id="fecha-desde"
            wrapperClassName="w-100 d-block"
            maxDate={filtros.fechaHasta || null}
          />
        </FormGroup>

        {/* FECHA HASTA */}
        <FormGroup className="mb-0" style={{ width: "220px" }}>
          <Label htmlFor="fecha-hasta" style={labelStyle}>
            Fecha hasta
          </Label>
          <DatePicker
            selected={filtros.fechaHasta}
            onChange={(fecha) => handleFechaChange("fechaHasta", fecha)}
            dateFormat="dd/MM/yyyy"
            className="form-control"
            placeholderText="dd-mm-aaaa"
            id="fecha-hasta"
            wrapperClassName="w-100 d-block"
            minDate={filtros.fechaDesde || null}
          />
        </FormGroup>

        {/* BOTONES DE ACCIÓN (CON LABEL INVISIBLE PARA ALINEACIÓN EXACTA) */}
        <FormGroup className="mb-0">
          <Label style={{ ...labelStyle, visibility: "hidden" }}>
            Acciones
          </Label>
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <Button
              onClick={onFiltrar}
              style={{
                backgroundColor: "#001873",
                borderColor: "#001873",
                color: "#ffffff",
                height: "38px",
                padding: "0 1.25rem",
                borderRadius: "4px",
                fontWeight: "500"
              }}
            >
              Filtrar
            </Button>

            <Button
              onClick={onLimpiar}
              style={{
                backgroundColor: "#f2f2f2",
                borderColor: "#e0e0e0",
                color: "#333333",
                height: "38px",
                padding: "0 1rem",
                borderRadius: "4px",
                fontWeight: "500"
              }}
            >
              Limpiar filtros
            </Button>
          </div>
        </FormGroup>

      </div>
    </div>
  );
};

export default FiltrosCompromisos;